import React from "react";
import SectionHeading from "../ui/SectionHeading";
import FAQ from "../ui/FAQ";

const faqItems = [
  {
    question: "What services does Professional Service Associates provide?",
    answer:
      "Professional Service Associates offers a comprehensive range of services including taxation, VAT management, BIDA and RJSC related work, accounting solutions, and company matters & licensing. Our experts provide personalized guidance for both individuals and businesses.",
  },
  {
    question: "How can I prepare for my tax filing?",
    answer:
      "To prepare for tax filing, gather all relevant financial documents including income statements, expense receipts, investment records, and previous tax returns. Our team can provide a detailed checklist specific to your situation and guide you through the entire process.",
  },
  {
    question: "What is the VAT registration process in Bangladesh?",
    answer:
      "The VAT registration process in Bangladesh involves submitting an application to the relevant VAT office along with required documents such as trade license, TIN certificate, company registration documents, and bank account information. Our experts can handle the entire process for you, ensuring compliance with all requirements.",
  },
  {
    question: "How can PSA help with company formation?",
    answer:
      "PSA assists with all aspects of company formation including name clearance, preparation and submission of incorporation documents, registration with RJSC, obtaining TIN and VAT registration, and securing necessary business licenses. We ensure a smooth and compliant process from start to finish.",
  },
  {
    question: "What documents are needed for BIDA registration?",
    answer:
      "BIDA registration typically requires documents such as the company profile, board resolution, project proposal, financial statements or plan, passport copies of foreign investors/directors, and joint venture agreement (if applicable). Our experts can provide a complete checklist based on your specific situation.",
  },
  {
    question: "How often should my business conduct tax planning?",
    answer:
      "Tax planning should be a continuous process, but formal reviews are recommended at least quarterly and before any major business decisions. Year-end tax planning is crucial to optimize your tax position before the filing season begins. Our team provides ongoing support to ensure you take advantage of all available opportunities.",
  },
  {
    question: "What are the benefits of professional accounting services?",
    answer:
      "Professional accounting services provide accurate financial reporting, ensure regulatory compliance, optimize tax positions, identify cost-saving opportunities, improve cash flow management, and provide valuable insights for business decision-making. This allows you to focus on your core business activities while having confidence in your financial management.",
  },
  {
    question: "How do I know which business structure is right for my company?",
    answer:
      "The optimal business structure depends on factors such as liability concerns, tax considerations, capital requirements, management preferences, and growth plans. Our experts evaluate your specific situation and goals to recommend the most advantageous structure and guide you through the formation process.",
  },
];

const FAQList = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <SectionHeading
          title="Frequently Asked Questions"
          subtitle="Find answers to common questions about our services and tax-related matters."
          center
        />

        <div className="max-w-3xl mx-auto mt-12">
          <FAQ items={faqItems} />
        </div>
      </div>
    </section>
  );
};

export default FAQList;
